import { Loader2, Smartphone } from "lucide-react";
import EmployeeApp from "./employee/EmployeeApp";
import PhoneFrame from "./employee/PhoneFrame";
import { EmployeeSystemLogin } from "./employee/EmployeeSystemLogin";
import { useEmployeeSession } from "./employee/useEmployeeSession";

export default function EmployeeSystem() {
    const session = useEmployeeSession();
    return (
        <div className="min-h-dvh w-full bg-slate-100 flex flex-col items-center justify-center sm:py-4 sm:px-4" data-testid="employee-system-stage">
            <div className="hidden sm:flex mb-3 items-center gap-2 text-xs font-semibold text-slate-600" data-testid="employee-system-label"><Smartphone className="w-4 h-4" />Medarbejdersystem</div>
            <PhoneFrame>
                {session.checking ? <div className="h-full flex items-center justify-center" data-testid="employee-system-loading"><Loader2 className="w-6 h-6 animate-spin text-blue-600" /></div>
                    : !session.token ? <EmployeeSystemLogin onLogin={session.login} sessionError={session.error} />
                    : !session.profile ? <div className="h-full flex flex-col justify-center gap-4 px-6">
                        <p role="alert" data-testid="employee-system-load-error" className="text-sm text-red-700">{session.error}</p>
                        <button onClick={session.retry} data-testid="employee-system-retry" className="h-11 rounded-xl bg-blue-600 text-white">Prøv igen</button>
                        <button onClick={session.logout} data-testid="employee-system-switch-account" className="h-11 rounded-xl border border-slate-200">Skift konto</button>
                    </div> : <EmployeeApp key={session.token} client={session.client} onLogout={session.logout} tabKey={session.tabKey} />}
            </PhoneFrame>
        </div>
    );
}